import api from './apiClient';

const apiTranslateCaption = async (text, onUnavailable) => {
    try {
        const response = await api.post('/api/captions/translate-caption', { text });
        return {
            text: response.data.translation || text,
            sourceLanguage: response.data.sourceLanguage || null,
        };
    } catch (error) {
        console.error('Translation error:', error);
        onUnavailable?.(error);
        return { text, sourceLanguage: null };
    }
};

export default apiTranslateCaption;
